import theme from "../../theme";

/**
 * Styles for the Dashboard component
 * @module DashboardSx
 * @description Contains all theme-aware style objects for the Dashboard layout and components
 */

/**
 * Main container styles for the Dashboard layout
 * @type {Object}
 */
export const dashboardContainer = {
  display: "flex",
  width: "100%",
  backgroundColor: theme.palette.background.default,
  fontFamily: theme.typography.fontFamily
};

/**
 * Styles for the main content area container
 * @type {Object}
 */
export const mainContentContainer = {
  flex: "1",
  display: "flex",
  flexDirection: "column",
  background: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius * 2, // 6px if default is 3
  margin: theme.spacing(2),
  boxShadow: theme.shadows[2]
};

/**
 * Styles for paper components within the Dashboard
 * @type {Object}
 */
export const paperContainer = {
  height: "100%",
  padding: theme.spacing(2, 4), // 1rem top/bottom, 2rem left/right
  borderRadius: theme.shape.borderRadius * 2,
  backgroundColor: theme.palette.background.paper
};

/**
 * Styles for content boxes
 * @type {Object}
 */
export const contentBox = {
  display: "flex",
  width: "100%",
  flexDirection: "column",
  height: "100%",
  color: theme.palette.text.primary
};

/**
 * Styles for header containers
 * @type {Object}
 */
export const headerContainer = {
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`
};

/**
 * Styles for button containers
 * @type {Object}
 */
export const buttonsContainer = {
  display: "flex",
  justifyContent: "center",
  gap: theme.spacing(2),
  marginTop: theme.spacing(4),
  padding: theme.spacing(2, 0)
};

/**
 * Styles for back buttons
 * @type {Object}
 */
export const backButton = {
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 3),
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText
  }
};

/**
 * Styles for continue buttons
 * @type {Object}
 */
export const continueButton = {
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 3),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark
  },
  '&:disabled': {
    backgroundColor: theme.palette.action.disabledBackground
  }
};